angular
  .module('resyApp')
  .controller('StaticPageCtrl', StaticPageCtrl);

function StaticPageCtrl($scope, $location, metadata) {
  const thisCtrl = this;

  function isCurrent(href) {
    return ((`/${href}`) === $location.path());
  }

  const keys = Object.keys(metadata);
  keys.forEach(
    (key) => {
      $scope.metadata[key] = metadata[key];
    }
  );

  thisCtrl.isCurrent = isCurrent;
}

export default () => {};
